import { render, staticRenderFns } from "./AvatarUsuario.vue?vue&type=template&id=7995b9a8&scoped=true"
import script from "./AvatarUsuario.vue?vue&type=script&lang=ts"
export * from "./AvatarUsuario.vue?vue&type=script&lang=ts"
import style0 from "./AvatarUsuario.vue?vue&type=style&index=0&id=7995b9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7995b9a8",
  null
  
)

export default component.exports